import { WIS_MESSAGE_APP, WIS_MESSAGE_TYPE } from '../constants';

export default function getWisMessageInfo(message) {
    let messageType = WIS_MESSAGE_TYPE.UNKNOWN;
    let messageApp = WIS_MESSAGE_APP.UNKNOWN;

    const messageLabel = message?.message?.toLowerCase();

    if (messageLabel && messageLabel.length > 0) {
        switch (messageLabel.substr(0, 2)) {
        case 'e_':
            messageType = WIS_MESSAGE_TYPE.EVENT;
            break;
        case 'r_':
            messageType = WIS_MESSAGE_TYPE.RESPONSE;
            break;
        default:
            messageType = WIS_MESSAGE_TYPE.UNKNOWN;
            break;
        }

        switch (messageLabel.substr(2)) {
        case 'wiservice':
            messageApp = WIS_MESSAGE_APP.WISERVICE;
            break;
        case 'headset':
            messageApp = WIS_MESSAGE_APP.HEADSET;
            break;
        case 'screen_control':
            messageApp = WIS_MESSAGE_APP.SCREEN_CONTROL;
            break;
        default:
            messageApp = WIS_MESSAGE_APP.UNKNOWN;
            break;
        }
    }

    return {
        messageType,
        messageApp
    };
}
